import Navbar from 'src/components/Layout/Navbar/Navbar';
import Footer from 'src/components/Layout/Footer/Footer';
import { Outlet } from 'react-router-dom';
import { LayoutWrapperContainer } from './layoutWrapper.styles';
import { useScrollToTop } from 'src/hooks/useScrollToTop';
import { useSelector } from 'react-redux';
import { loadingMessageSelector, loadingSelector } from 'src/store/User/user.slice';
import Spiner from 'src/components/shared/loaders/Spin';

export const LayoutWrapper = () => {
  useScrollToTop();
  const isLoading = useSelector(loadingSelector);
  const loadingMessage = useSelector(loadingMessageSelector);

  return (
    <LayoutWrapperContainer>
      <Navbar />
      {isLoading ? <Spiner message={loadingMessage} /> : null}
      {/* This ideally has to be a main label, but actually we have various mains nested into the app, so will be bad for SEO */}
      <div className="main-wrapper">
        <Outlet />
      </div>
      <Footer />
    </LayoutWrapperContainer>
  );
};
